import { EventBus } from '../../components/front/vue/Utils/event-bus'
let mobile = require('is-mobile')
let vis = (function(){
    let stateKey, eventKey, keys = {
        hidden: "visibilitychange",
        webkitHidden: "webkitvisibilitychange",
        mozHidden: "mozvisibilitychange",
        msHidden: "msvisibilitychange"
    };

    for (stateKey in keys) {
        if (stateKey in document) {
            eventKey = keys[stateKey];
            break;
        }
    }

    return function(c) {
        if (c) document.addEventListener(eventKey, c);
        return !document[stateKey];
    }
})();

vis(function(){
    /*if(mobile() && vis()){
        EventBus.$emit('browser-visibility-changed')
        //location.reload()
    }*/
    if(vis()){
        EventBus.$emit('browser-visibility-changed', true)
    }
});
